import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const SaveEntityContext = createContext(null);

type Props = {
  children: ReactElement;
};

const SaveEntityProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("onboarding/verify/save-entity", payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <SaveEntityContext.Provider value={contextValue}>
      {children}
    </SaveEntityContext.Provider>
  );
};

export default SaveEntityProvider;
